/**
 * Feature-usage flags (Sep 2026), per browser: a feature records that it was
 * used, and Home's usage tips (home/tips.ts) skip tips about it. Kept in its
 * own module so the features can import it without pulling in the tips.
 */
export type UsedFeature = 'palette' | 'shortcuts' | 'guide' | 'split' | 'goto';
const usedKey = (f: UsedFeature) => `daaily.used.${f}`;

export function markUsed(f: UsedFeature) {
  try { localStorage.setItem(usedKey(f), '1'); } catch { /* ignore */ }
}
export function wasUsed(f: UsedFeature): boolean {
  try { return localStorage.getItem(usedKey(f)) === '1'; } catch { return false; }
}
